// extracted by mini-css-extract-plugin
export default {"item":"Item_item__3RaVP"};